export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp()
  const auth = useAuthStore()
  const toast = useToast();

  if (auth.logged && !auth.user.roles.includes('admin')) {
    return nuxtApp.runWithContext(() => {

      toast.add({
        severity: "error",
        summary: "Access denied.",
        life: 3000,
      });

      return navigateTo('/auth/login')
    })
  }
})
